import React from 'react';
import cn from 'classnames';
import Layout from '../components/Layout';
import { useInfiniteScroll } from '../hooks/request';
import { GROUPS_LIST } from '../urls';
import Table from '../components/common/Table';
import { useQueryParams } from '../hooks/queryString';
import GroupItem from '../components/GroupItem';
import Button from '../components/common/Button';
import GroupCreate from '../components/GroupCreate';
import { useModal } from '../hooks/modal';
import { checkForAdmin, checkPermission as cp } from '../utils/auth';
import { PermissionDenied } from '../components/PermissionDenied';
// import FilterByBranch from '../components/common/FilterByBranch';
import AcademyHeader from '../components/AcademyHeader';

export default function Group() {
	const isAdmin = checkForAdmin();
	const params = useQueryParams();

	// Tab state management
	const [activeTab, setActiveTab] = React.useState('all');

	// Get group_type value based on active tab
	const getGroupTypeParam = () => {
		switch (activeTab) {
			case 'toq':
				return 'toq_kun';
			case 'juft':
				return 'juft_kun';
			case 'boshqa':
				return 'boshqa_kunlar';
			default:
				return undefined;
		}
	};

	// Create params object with group_type filter
	const apiParams = {
		...params,
		...(getGroupTypeParam() && { group_type: getGroupTypeParam() })
	};

	const groups = useInfiniteScroll({ url: GROUPS_LIST, params: apiParams });
	const groupsList = groups.response?.results || [];
	const filteredGroups = groupsList.filter(item => !item.isArchive);

	// Reload groups when tab changes
	React.useEffect(() => {
		groups.reload();
	}, [activeTab]);

	const [showCreateModal, hideCreateModal] = useModal(
		<GroupCreate
			onSuccess={() => {
				hideCreateModal();
				groups.reload();
			}}
			onCancel={() => hideCreateModal()}
		/>
	);

	if (!cp('academy.view_group')) {
		return <PermissionDenied />;
	}

	return (
		<Layout>
			<AcademyHeader />

			{/* Header section with tabs and create button */}
			<div style={{
				display: 'flex',
				justifyContent: 'space-between',
				alignItems: 'flex-end',
				marginTop: 20,
				marginBottom: 30,
				gap: 20,
				flexWrap: 'wrap'
			}}>
				{/* Group Type Tabs */}
				<div className="group-tabs" style={{ flex: 1, minWidth: '400px' }}>
					<div className="tab-container" style={{
						display: 'flex',
						background: '#f8f9fa',
						borderRadius: '12px',
						padding: '4px',
						boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
						gap: '4px'
					}}>
						<button
							className={`tab-button ${activeTab === 'all' ? 'active' : ''}`}
							onClick={() => setActiveTab('all')}
							style={{
								flex: 1,
								padding: '12px 20px',
								border: 'none',
								borderRadius: '8px',
								fontSize: '14px',
								fontWeight: '500',
								cursor: 'pointer',
								transition: 'all 0.3s ease',
								background: activeTab === 'all' ? '#ffffff' : 'transparent',
								color: activeTab === 'all' ? '#2c3e50' : '#7f8c8d',
								boxShadow: activeTab === 'all' ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'
							}}
						>
							📚 Все группы
						</button>
						<button
							className={`tab-button ${activeTab === 'toq' ? 'active' : ''}`}
							onClick={() => setActiveTab('toq')}
							style={{
								flex: 1,
								padding: '12px 20px',
								border: 'none',
								borderRadius: '8px',
								fontSize: '14px',
								fontWeight: '500',
								cursor: 'pointer',
								transition: 'all 0.3s ease',
								background: activeTab === 'toq' ? '#ffffff' : 'transparent',
								color: activeTab === 'toq' ? '#2c3e50' : '#7f8c8d',
								boxShadow: activeTab === 'toq' ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'
							}}
						>
							🗓️ Нечетные дни
						</button>
						<button
							className={`tab-button ${activeTab === 'juft' ? 'active' : ''}`}
							onClick={() => setActiveTab('juft')}
							style={{
								flex: 1,
								padding: '12px 20px',
								border: 'none',
								borderRadius: '8px',
								fontSize: '14px',
								fontWeight: '500',
								cursor: 'pointer',
								transition: 'all 0.3s ease',
								background: activeTab === 'juft' ? '#ffffff' : 'transparent',
								color: activeTab === 'juft' ? '#2c3e50' : '#7f8c8d',
								boxShadow: activeTab === 'juft' ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'
							}}
						>
							📅 Четные дни
						</button>
						<button
							className={`tab-button ${activeTab === 'boshqa' ? 'active' : ''}`}
							onClick={() => setActiveTab('boshqa')}
							style={{
								flex: 1,
								padding: '12px 20px',
								border: 'none',
								borderRadius: '8px',
								fontSize: '14px',
								fontWeight: '500',
								cursor: 'pointer',
								transition: 'all 0.3s ease',
								background: activeTab === 'boshqa' ? '#ffffff' : 'transparent',
								color: activeTab === 'boshqa' ? '#2c3e50' : '#7f8c8d',
								boxShadow: activeTab === 'boshqa' ? '0 2px 4px rgba(0,0,0,0.1)' : 'none'
							}}
						>
							🌟 Другие дни
						</button>
					</div>
				</div>

				{/* Create Group Button */}
				{cp('academy.add_customer') && (
					<Button style={{ marginLeft: 10, marginBottom: 5 }} onClick={showCreateModal} text='Создать Группу' icon='ion-md-add' className='is-pulled-right is-link is-outlined is-size-6 ml-5' />
				)}
			</div>

			<Table
				style={{ paddingBottom: 50 }}
				loading={groups.loading}
				showEmptyMessage={false}
				columns={{ index: '', group: 'Название', timelines: 'Расписание занятий', students: 'Студенты', teacher: 'Учитель', subject: 'Предмет', room: 'Кабинет', actions: '' }}
				items={activeTab === 'all' ? groupsList : filteredGroups}
				renderItem={(item, index) => <GroupItem index={index} key={item.id} onUpdate={groups.reload} onDelete={groups.reload} item={item} />}
				children={
					<div ref={groups.ref} className='has-text-grey-light is-italic has-text-centered'>
						{!groups.hasMore && !groups.loading && groups.length !== 0 ? 'Загрузили всех групп' : ''}
					</div>
				}
			/>
		</Layout>
	);
}
